import 'global-nav/dist/navbar.js';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSidenav } from '@angular/material/sidenav';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BmdCookieService, LoaderService, NavbarService, SidenavService } from '@service';
import { environment } from '../environments/environment.prd';

@Component({
  selector: 'bmd-root',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('searchInput') input: ElementRef;

  sidenavOpen = true;
  subscriptions: Subscription[] = [];
  mode: 'over' | 'push' | 'side' = 'side';

  constructor(
    private translateService: TranslateService,
    private cookieService: BmdCookieService,
    private sidenavService: SidenavService,
    public loaderService: LoaderService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    protected navbarService: NavbarService,
  ) {
    this.loaderService.regexEndpoints = ['ess-parameters', 'permission', 'run'];
    this.loaderService.setExcludedUiUrls('?tab=events');
    this.matIconRegistry.addSvgIcon(
      'noData',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/svg-icons/no-data.svg'),
    );
  }

  ngOnInit(): void {
    const { defaults } = environment;
    const locale = this.cookieService.getI18NLocale() || 'en-us';
    const brand = this.cookieService.getI18NBrand() || defaults.brand.toUpperCase();
    this.translateService.setDefaultLang(`${defaults.locale}.${defaults.brand.toUpperCase()}`);
    const translateSubscription = this.translateService.use(`${locale}.${brand}`).subscribe(() => {
      this.translateService.get('APP.TITLE').subscribe(result => {
        document.title = result;
      });
    });

    const closeSubscription = this.sidenavService.close$.subscribe(() => (this.sidenavOpen = false));
    this.subscriptions.push(...[translateSubscription, closeSubscription]);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }

  sidenavContentStyle(): CSSStyleDeclaration {
    const style = window.getComputedStyle(document.body);
    const dockWidth = +style.getPropertyValue('--sidenav-dock-width').match(/\d+/)[0];
    const fullWidthWidth = document.querySelector('mat-sidenav').clientWidth;
    const matContentMargin = this.sidenavOpen ? `${fullWidthWidth - 30}px` : `${dockWidth + 5}px`;
    return {
      marginLeft: this.mode !== 'over' ? matContentMargin : `${dockWidth + 5}px !important`,
    } as CSSStyleDeclaration;
  }

  isLargeScreen(): boolean {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return width > 1280;
  }

  getMode(): 'over' | 'push' | 'side' {
    this.mode = this.isLargeScreen() ? 'side' : 'over';
    return this.mode;
  }
}
